import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const chapters = [
  {
    n: "01",
    title: "Perforated Light Diffusion",
    copy: "Intricate jar cutouts create meditative lantern silhouettes on walls while maintaining optimal oxygen flow for an even burn.",
  },
  {
    n: "02",
    title: "Zero Paraffin, Zero Toxins",
    copy: "Crafted strictly using renewable soy and pure botanical extracts. Free from benzene, artificial phthalates, or chemical soot.",
  },
  {
    n: "03",
    title: "Long 45+ Hour Burn",
    copy: "Formulated for deep, slow burning in heavy-duty 5-inch glass jars that can be easily repurposed as planters or organizers.",
  },
];

export const Chapters = () => (
  <section id="product-details" className="py-20 md:py-28 bg-brandSand/40 border-b border-brandSand">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <Reveal className="text-center max-w-2xl mx-auto mb-14">
        <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brandTerracotta">The Manifesto</span>
        <h2 className="font-serif text-3xl sm:text-4xl font-bold mt-3">Mindfully made for health &amp; calm</h2>
        <p className="text-brandDarkSlate/75 mt-3 text-sm sm:text-base">
          Unlike petroleum paraffin candles, our perforated jars purify air and distribute subtle natural aroma safely.
        </p>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {chapters.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.12} className="h-full">
            <motion.article
              data-testid={`chapter-card-${c.n}`}
              whileHover={{ y: -8 }}
              transition={{ type: "spring", stiffness: 250, damping: 20 }}
              className="h-full bg-white p-8 rounded-2xl border border-brandSand shadow-sm hover:shadow-xl hover:shadow-brandTerracotta/10 transition-shadow space-y-4"
            >
              <span className="block font-serif text-6xl font-bold leading-none text-brandTerracotta/25">{c.n}</span>
              <h3 className="font-serif font-bold text-xl">{c.title}</h3>
              <p className="text-sm text-brandDarkSlate/80 leading-relaxed">{c.copy}</p>
            </motion.article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
